function f(o, c) {
  var l = o.createReader(), r = [];
  function i() {
    l.readEntries(function(a) {
      var e = Array.prototype.slice.apply(a);
      r = r.concat(e);
      var n = !e.length;
      n ? c(r) : i();
    });
  }
  i();
}
var u = function(c, l, r) {
  var i = function a(e, n) {
    e.path = n || "", e.isFile ? e.file(function(t) {
      r(t) && (e.fullPath && !t.webkitRelativePath && (Object.defineProperties(t, {
        webkitRelativePath: {
          writable: !0
        }
      }), t.webkitRelativePath = e.fullPath.replace(/^\//, ""), Object.defineProperties(t, {
        webkitRelativePath: {
          writable: !1
        }
      })), l([t]));
    }) : e.isDirectory && f(e, function(t) {
      t.forEach(function(s) {
        a(s, "".concat(n).concat(e.name, "/"));
      });
    });
  };
  c.forEach(function(a) {
    i(a.webkitGetAsEntry());
  });
};
export {
  u as default
};
//# sourceMappingURL=traverseFileTree.mjs.map
